import LearningResult from './LearningResult';

export default LearningResult;
